import classnames from 'classnames';
import type { InputHTMLAttributes, Ref } from 'react';
import Error from './Error';
import Label from './Label';
import type { FormError } from './types';

interface TextProps {
  disabled?: boolean;
  error?: FormError;
  label?: string | null;
  maxLength?: number | null;
  name: string;
  placeholder?: string | null;
  ref?: Ref<HTMLInputElement>;
  register: object;
  testId?: string;
  type?: string;
}

export const Text = ({
  disabled = false,
  error,
  label = null,
  maxLength = null,
  name,
  placeholder = null,
  ref,
  register,
  testId = '',
  type = 'text',
}: TextProps) => {
  const inputProps = {
    className: classnames('form-control', { 'is-invalid': error }),
    'data-testid': testId,
    disabled,
    id: name,
    label,
    maxLength,
    name,
    placeholder,
    ref,
    type,
    ...register,
  } as InputHTMLAttributes<HTMLInputElement>;

  return (
    <div className="form-group">
      {label && <Label name={name}>{label}</Label>}
      <input {...inputProps} />
      <Error>{error?.message}</Error>
    </div>
  );
};

export default Text;
